import { jsxs as r, jsx as a } from "react/jsx-runtime";
import * as g from "react";
import { cn as s } from "../../../lib/utils.js";
const h = g.forwardRef(({ className: i, value: l = 0, max: t = 100, label: e, showValue: n = !1, variant: o = "default", size: m = "md", ...c }, u) => {
  const d = Math.min(Math.max(l / t * 100, 0), 100), f = {
    sm: "h-1.5",
    md: "h-2.5",
    lg: "h-4"
  }, p = {
    default: "bg-lpr-teal",
    success: "bg-lpr-green",
    warning: "bg-lpr-gold",
    error: "bg-lpr-red"
  };
  return r("div", { ref: u, className: s("w-full space-y-2", i), ...c, children: [(e || n) && r("div", { className: "flex items-center justify-between text-sm", children: [e && a("span", { className: "font-medium text-text-primary", children: e }), n && r("span", { className: "text-text-secondary", children: [Math.round(d), "%"] })] }), a("div", { className: s("relative w-full overflow-hidden rounded-full bg-bg-muted dark:bg-lpr-neutral/20", f[m]), children: a("div", { className: s("h-full rounded-full transition-all duration-500 ease-luxury shadow-card", p[o]), style: { width: `${d}%` }, role: "progressbar", "aria-valuenow": l, "aria-valuemin": 0, "aria-valuemax": t }) })] });
});
h.displayName = "Progress";
export {
  h as Progress
};
//# sourceMappingURL=Progress.js.map
